import { $methodKey } from "./consts";
import { defineMethod } from "./defineMethod";
/**
 * 初始化$methods对象
 * @param instance
 * @returns
 */
export function init$methods(instance) {
  const {
    sourceConfig
  } = instance.options;
  const methods = sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.methods;
  if (!Array.isArray(methods)) {
    return;
  }
  if (!instance[$methodKey]) {
    Object.defineProperty(instance, $methodKey, {
      value: {},
      enumerable: false,
      writable: true
    });
  }
  methods.forEach(m => {
    try {
      defineMethod(instance, m);
    } catch (error) {
      console.error(`数据源方法初始化失败 ${sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.collectionId} ${m.id}`, error);
    }
  });
}
//# sourceMappingURL=init$methods.js.map
